import React from 'react';

/**
 * 4-cell summary footer for the Gantt chart: phase counts, completion,
 * time-elapsed progress bar, and total phase spend vs budget.
 */
const GanttSummaryRow = ({
  totalPhases,
  completedCount,
  timeElapsedPct,
  totalSpent,
  totalBudget,
  formatCurrency,
}) => {
  return (
    <div className="border-t-2 border-black bg-zinc-50 grid grid-cols-2 sm:grid-cols-4 divide-x-2 divide-zinc-200">
      <div className="p-3" data-testid="gantt-summary-total">
        <p className="text-[10px] font-heading font-bold uppercase tracking-[0.15em] text-zinc-500 mb-1">
          Phases
        </p>
        <p className="font-mono text-lg font-bold text-zinc-900">{totalPhases}</p>
      </div>
      <div className="p-3" data-testid="gantt-summary-completed">
        <p className="text-[10px] font-heading font-bold uppercase tracking-[0.15em] text-zinc-500 mb-1">
          Completed
        </p>
        <p className="font-mono text-lg font-bold text-emerald-600">
          {completedCount}
          <span className="text-zinc-400 text-xs"> / {totalPhases}</span>
        </p>
      </div>
      <div className="p-3" data-testid="gantt-summary-elapsed">
        <p className="text-[10px] font-heading font-bold uppercase tracking-[0.15em] text-zinc-500 mb-1">
          Time Elapsed
        </p>
        {timeElapsedPct === null ? (
          <p className="font-mono text-sm text-zinc-400">No dates</p>
        ) : (
          <>
            <p className="font-mono text-lg font-bold text-zinc-900">
              {timeElapsedPct.toFixed(0)}%
            </p>
            <div className="h-1.5 bg-zinc-200 mt-1 overflow-hidden">
              <div
                className="h-full bg-orange-500"
                style={{ width: `${timeElapsedPct}%` }}
              />
            </div>
          </>
        )}
      </div>
      <div className="p-3" data-testid="gantt-summary-budget">
        <p className="text-[10px] font-heading font-bold uppercase tracking-[0.15em] text-zinc-500 mb-1">
          Phase Spend
        </p>
        <p className="font-mono text-sm font-bold text-zinc-900 truncate">
          {formatCurrency(totalSpent)}
        </p>
        <p className="font-mono text-[10px] text-zinc-500 truncate">
          of {formatCurrency(totalBudget)}
        </p>
      </div>
    </div>
  );
};

export default GanttSummaryRow;
